import type { RefreshRexListingRequest } from '@urbanx/agx.rex.client';
import { z } from 'zod';

const storageKey = 'support-rex-listing-refresh';
const savedRequestSchema = z.object({
  operationId: z.uuid(),
  agencyId: z.uuid(),
  listingId: z.number().int().positive(),
});

export function readSavedRexListingRefresh(): RefreshRexListingRequest | null {
  const raw = sessionStorage.getItem(storageKey);
  if (!raw) return null;

  try {
    const saved = savedRequestSchema.safeParse(JSON.parse(raw));
    return saved.success ? saved.data : null;
  } catch {
    return null;
  }
}

export function saveRexListingRefresh(request: RefreshRexListingRequest) {
  sessionStorage.setItem(storageKey, JSON.stringify(request));
}

export function clearSavedRexListingRefresh() {
  sessionStorage.removeItem(storageKey);
}
